/**
 * Whether an IBAN is well formed and its check digits are right (ISO 13616, mod 97). It catches a
 * typo before a payment file carries it to the bank, which would refuse the whole file.
 *
 * @param iban - The IBAN, with or without spaces, in any case.
 */
export function isValidIban(iban: string) {
	const compact = iban.replace(/\s+/g, "").toUpperCase();
	if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(compact)) return false;
	const rearranged = compact.slice(4) + compact.slice(0, 4);
	let remainder = 0;
	for (const character of rearranged) {
		const digits = /\d/.test(character) ? character : String(character.charCodeAt(0) - 55);
		for (const digit of digits) remainder = (remainder * 10 + Number(digit)) % 97;
	}
	return remainder === 1;
}
